<template>
    <div>
        <div v-if="! canceling">
            <button @click.prevent="cancel()" ref="submit" class="w-full py-4 text-18 font-semibold text-white bg-red-500 hover:bg-red-600 whitespace-nowrap rounded-3 duration-300">
                {{ trans.get('rezervace.storno_tlacitko') }} <span class="block mt-0.5 text-13 font-regular">{{ this.label }}</span>
            </button>
        </div>
        <div v-else>
            <div class="flex items-center justify-center w-full py-4 text-18 font-semibold text-white text-center bg-red-300 rounded-3 duration-300 cursor-not-allowed">
                <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>

                <div class="ml-2 md:ml-4">
                    {{ trans.get('rezervace.storno_tlacitko') }} <span class="block mt-0.5 text-13 font-regular">{{ this.label }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: String,
    },

    data: function () {
        return {
            canceling: false,
            form: Object,
        }
    },

    mounted: function() {
        this.form = this.$refs.submit.closest('form');
    },

    methods: {
        cancel() {
            if (! confirm('Opravdu si přejete objednávku zrušit?')) {
                return;
            }

            this.canceling = true;

            setTimeout(() => {
                this.form.submit();
            }, 25);
        },
    },
}
</script>
